<template>
  <div class="task-completion-section designer-task custom-scroll">
    <div class="adaptive-icon-files">
      <files-uploader
        class="app-icon"
        show-label
        mode="list"
        big-pictures
        :limit="1"
        :img-row="2"
        :files="initFiles.appIcon"
        can-picture-open>
        <template #label>
          <p class="label">
            {{ appIconLabel }}
          </p>
        </template>
      </files-uploader>

      <files-uploader
        class="app-icon-bg"
        show-label
        mode="list"
        big-pictures
        :limit="1"
        :img-row="2"
        :files="initFiles.appIconBg"
        can-picture-open>
        <template #label>
          <p class="label">
            {{ appIconBgLabel }}
          </p>
        </template>
      </files-uploader>
    </div>

    <el-tabs type="card" class="upperline-style">
      <el-tab-pane v-for="lang in displayedLanguage" :key="lang.id" :label="`${lang.name} (${getLangTitle(lang)})`">
        <language-screenshots :language-item="lang"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { ElTabPane, ElTabs } from 'element-plus'
import LanguageScreenshots from './LanguageScreenshots'
import FilesUploader from '@/components/UIComponents/Custom/FilesUploader'
import { mapGetters } from 'vuex'

export default {
  name: 'TaskCompletionSection',
  components: {
    FilesUploader,
    LanguageScreenshots,
    ElTabs,
    ElTabPane
  },
  props: {
    language: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      initFiles: {
        appIcon: [],
        appIconBg: []
      }
    }
  },
  computed: {
    ...mapGetters(['selectedApplication']),
    displayedLanguage() {
      return this.selectedApplication.language.filter(item => !item.use_default_screens)
    },
    appIconLabel() {
      return this.$t('Responsive icon front layer image')
    },
    appIconBgLabel() {
      return this.$t('Responsive icon background image')
    }
  },
  methods: {
    getLangTitle(lang) {
      try {
        return this.$store.getters.types.language.find(item => item.name === lang.name).meta[this.$i18n.locale].title
      } catch (e) {
        return lang.title
      }
    }
  },
  beforeMount() {
    this.initFiles.appIcon = [this.selectedApplication.icon]
    this.initFiles.appIconBg = [this.selectedApplication.icon_background]
  }
}
</script>

<style scoped>

</style>
